import { Divider } from 'newcomponents/UI/Divider';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const GoalScoredSkeleton = () => {
  const SkeletonElement = (
    <Skeleton
      active
      title={{
        width: 100,
        style: {
          height: 14,
          textAlign: 'center',
          margin: ' 0 auto',
          marginTop: 5
        }
      }}
      paragraph={false}
      className="matchHeader__skeleton"
    />
  );

  return (
    <>
      <div className="marketStatistics__header">
        <div className="marketStatistics__header__title">
          <Skeleton
            active
            title={{
              style: { width: 200, height: 16, margin: '0' }
            }}
            paragraph={false}
          />
        </div>
      </div>
      <div className="goalScored">
        <div className="marketStatisticsTemplateTabs">
          <Skeleton
            active
            title={{
              width: '100%',
              style: { height: 20, textAlign: 'center', margin: ' 0 auto' }
            }}
            paragraph={false}
            className="matchHeader__skeleton"
          />
        </div>
        <div className="statisticBox">
          <div className="previousMatches">
            <Skeleton
              active
              title={{
                width: 100,
                style: {
                  height: 15,
                  textAlign: 'center',
                  margin: ' 0 auto'
                }
              }}
              paragraph={false}
              className="matchHeader__skeleton"
            />
          </div>
          <div className="statisticBoxContent">
            <div className="statisticBox__column">
              <div className="statisticBox__column__score">
                {SkeletonElement}
              </div>
              <div className="statisticBox__column__teamName">
                {SkeletonElement}
              </div>
              <div className="statisticBox__column__info">
                {SkeletonElement}
              </div>
            </div>
            <Divider
              type="vertical"
              distance={8}
              className="statisticBoxDivider"
            />
            <div className="statisticBox__column">
              <div className="statisticBox__column__score">
                {SkeletonElement}
              </div>
              <div className="statisticBox__column__teamName">
                {SkeletonElement}
              </div>
              <div className="statisticBox__column__info">
                {SkeletonElement}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="marketStatistics__footer">
        <Skeleton
          active
          title={{
            style: { width: 150, height: 16, margin: '0' }
          }}
          paragraph={false}
        />
      </div>
    </>
  );
};
